import React, { useState } from 'react'
import Modal from '../../../common/Modal'
import { Button } from 'react-dxd-components'
import { Grid, GridColumn, GridRow } from 'semantic-ui-react'
import Card from '../../../common/Card'
import { useDispatch } from 'react-redux'
import { setField } from '../../../../state/slice/form'

export default function SuggestedAddressModal ({ rootPath, addressObject }) {

  const dispatch = useDispatch()
  const [open, setOpen] = useState()

  const updateAddress = () => {
    const { code1validated, suggested, include, ...addressParts } = addressObject
    dispatch(setField(`${rootPath}`, {
      ...addressObject,
      ...Object.keys(addressParts).reduce((o, k) => {
        return {
          ...o,
          [k]: { ...addressParts[k], value: addressObject.suggested[k].value }
        }
      }, {})
    }))
    dispatch(setField(`${rootPath}.code1validated.value`, 'true'))
    setOpen(false)
  }

  const keepAddress = () => {
    dispatch(setField(`${rootPath}.code1validated.value`, 'true'))
    setOpen(false)
  }

  return <>
    <Button onClick={() => setOpen(true)} className='link-btn' tertiary>Review Suggestion</Button>
    <Modal
      id='suggested-address-modal'
      closeIcon
      open={open}
      onClose={() => setOpen(false)}
      closeOnDimmerClick
    >
      <Grid container stackable>
        <GridRow centered>
          <GridColumn width={16}>
            <h4>A suggested address has been found. Which would you like to use?</h4>
          </GridColumn>
        </GridRow>
        <GridRow>{[
          {
            title: 'Original',
            button: 'Keep Original',
            addressObject: addressObject,
            onClick: keepAddress
          },
          {
            title: 'Suggested',
            button: 'Use Suggested',
            addressObject: addressObject.suggested,
            onClick: updateAddress
          }
        ].map(({ title, button, addressObject, onClick }, i) => {
          return <GridColumn key={i} computer={8} tablet={8} mobile={16}>
            <Card title={title} className='address-card'>
              <span>{addressObject.street?.value}</span><br />
              {addressObject.street2?.value && <span>, {addressObject.street2?.value}<br /></span>}
              <span>{addressObject.city?.value}, {addressObject.state?.value} {addressObject.zip?.value}</span>
              <br />
              <Button onClick={onClick} className='u-mT3'>
                {button}
              </Button>
            </Card>
          </GridColumn>
        })}
        </GridRow>
      </Grid>
    </Modal>
  </>
}
